import { waLink } from '@/config/site';
import { foto, img } from '@/lib/projetos';
import { ArrowLink, PillButton } from '@/components/apple/ui';

const HERO = foto(9, 2); // Copergás — Recife, PE

export default function Hero() {
  return (
    <section className="bg-white pt-14 md:pt-20">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 text-center">
        <p className="text-[14px] md:text-[17px] font-semibold text-[#C4500A] tracking-[-0.01em] animate-reveal" style={{ opacity: 0 }}>
          Mobiliário corporativo · Caruaru, PE
        </p>
        <h1
          className="mt-3 text-[40px] sm:text-[56px] md:text-[72px] lg:text-[80px] leading-[1.03] tracking-[-0.045em] font-semibold text-[#1D1D1F] animate-reveal delay-100"
          style={{ opacity: 0 }}
        >
          Ambientes profissionais
          <br className="hidden sm:block" /> à altura de grandes projetos.
        </h1>
        <p
          className="mt-5 md:mt-6 max-w-2xl mx-auto text-[19px] md:text-[24px] leading-[1.35] tracking-[-0.02em] text-[#6E6E73] animate-reveal delay-200"
          style={{ opacity: 0 }}
        >
          Mobiliário corporativo e soluções turnkey, do projeto à montagem.
        </p>
        <div
          className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-7 animate-reveal delay-300"
          style={{ opacity: 0 }}
        >
          <PillButton href={waLink('projetos')}>Falar sobre meu projeto</PillButton>
          <ArrowLink to="/cases">Ver projetos</ArrowLink>
        </div>
      </div>

      <div className="mt-12 md:mt-16 max-w-[1440px] mx-auto px-4 md:px-6">
        <figure className="animate-reveal-scale delay-300" style={{ opacity: 0 }}>
          <div className="overflow-hidden rounded-[18px] md:rounded-[28px] bg-[#F5F5F7]">
            <img
              src={img(HERO, 2000)}
              srcSet={`${img(HERO, 900)} 900w, ${img(HERO, 1400)} 1400w, ${img(HERO, 2000)} 2000w`}
              sizes="(min-width: 1440px) 1392px, 100vw"
              alt="Sala de reuniões da sede da Copergás, em Recife, com mobiliário entregue pela HomeOffice Premium"
              className="w-full aspect-[4/3] sm:aspect-[16/9] lg:aspect-[2/1] object-cover"
              loading="eager"
              fetchPriority="high"
              decoding="async"
            />
          </div>
          <figcaption className="mt-3 text-center text-[12px] md:text-[13px] text-[#6E6E73]">
            Sede da Copergás · Recife, PE
          </figcaption>
        </figure>
      </div>
    </section>
  );
}
